<template>
  <div v-if="mostrarOptin">
    <modal-template @close="toggleModal" class="override-modal">
      <template #header>
        <i class="icon-ic_close" @click="toggleModal" />
        <h2>{{ $t('optin.whatsapp.titulo') }}</h2>
      </template>
      <template #body>
        <p v-if="autorizado == null" v-html="$t('optin.whatsapp.pergunta')" />
        <template v-else>
          <p v-html="$t('optin.whatsapp.agradecimento')" />
          <br />
          <p v-if="autorizado" v-html="$t('optin.whatsapp.autorizado')" />
          <p v-else v-html="$t('optin.whatsapp.nao-autorizado')" />
        </template>
      </template>
      <template #footer>
        <div v-if="autorizado == null" class="wrap-autorizo-optin">
          <b-button
            class="button-terciary button-autorizo-optin"
            :loading="loading"
            @click="naoAutorizar"
          >
            {{ $t('optin.whatsapp.nao-autorizo') }}
          </b-button>
          <b-button
            class="button-secondary button-autorizo-optin"
            :loading="loading"
            @click="autorizar"
          >
            {{ $t('optin.whatsapp.autorizo') }}
          </b-button>
        </div>
        <div v-else>
          <b-button
            class="button-terciary button-autorizo-optin"
            @click="toggleModal"
          >
            {{ $t('optin.whatsapp.ok') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '../modal/ModalTemplate'
import { mapActions } from 'vuex'

export default {
  name: 'OptinModal',
  components: { ModalTemplate },
  emits: ['closeModal'],
  props: {
    paciente: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      autorizado: null,
      mostrarOptin: false,
      loading: false
    }
  },
  mounted() {
    this.verificarSeMostraOptin()
  },
  methods: {
    ...mapActions(['atualizarContato', 'getPaciente']),
    toggleModal() {
      this.mostrarModal(!this.mostrarOptin)
    },
    async autorizar() {
      this.confirmar(true)
    },
    async naoAutorizar() {
      this.confirmar(false)
    },
    verificarSeMostraOptin() {
      this.mostrarOptin =
        this.paciente.Celular &&
        `${this.paciente.Celular}` !== '-1' &&
        this.paciente.WhatsappOptin == null
    },
    mostrarModal(mostrar) {
      this.mostrarOptin = mostrar
    },
    confirmar(optin) {
      this.loading = true
      this.confirmarAsync(optin)
    },
    async confirmarAsync(optin) {
      const contato = {
        Celular: this.paciente.Celular,
        CodigoPessoa: this.paciente.Codigo,
        Email: this.paciente.Email,
        Telefone: this.paciente.TelefoneOpcional,
        WhatsappOptin: optin
      }

      this.atualizarContato(contato)
        .then(() => {
          this.autorizado = optin
          this.getPaciente(this.paciente.Prontuario)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/buttons';
@import '~@/assets/stylesheets/modal/base';

.wrap-autorizo-optin {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
}

.button-autorizo-optin {
  padding: 0px;
  margin: 0px !important;
  height: 2.5rem;
  width: 12.5rem;
}

.nao-autorizo-optin {
  cursor: pointer;
  border: 1px solid $orange-dark-light;
}
</style>
